import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface DeleteScriptDialogData {
  scriptTitle: string;
}

export interface DeleteScriptDialogResult {
  confirmed: boolean;
}

@Component({
  selector: 'app-delete-script-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './delete-script-dialog.component.html',
  styleUrl: './delete-script-dialog.component.less'
})
export class DeleteScriptDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteScriptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteScriptDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    this.dialogRef.close({ confirmed: true });
  }
}
